// import itemTemplate from '../templates/item.html';
// import itemGroupAddTemplate from '../templates/itemGroupAdd.html';
// import itemPreviewTemplate from '../templates/itemPreview.html';
// import HtmlDom from "../main/HtmlDom";
// import groupTemplate from "../templates/group.html";

let AI_helperItemClass = function (o, app, cb, type) {
    this.o = o;
    this.type = 'common'
    this.app = app;
    this.id = 0; //id_good
    this.img = '';
    this.name = '';
    this.package = 0;
    this.measure = '';
    this.priceRub = 0;
    this.enableStock = false;
    this.cnt_per_all = 0;
    this.stockAlt = '';
    this.stockColor = '';
    this.rec_count = 0;
    this.sum = 0;
    this.count = 0;
    this.default_rec = false;
    this.group = 0;
    this.rate = 0;
    this.last_count = 0;
    this.dbg = '';
    this.added = false;
    this.gdsInStock = 0;
    this.inputTimer = null;
    this.inputTimeout = 3000; //ms
    this.prihod = '';
    this.wholeSum = 0;
    this.curPrice = 0;
    this.price = 0;
    this.cashbackSum = 0;
    this.zaEdDeneg = 0;
    this.curRate = 1;
    this.priceGroup = 0;
    this.colorGroup = 0;
    this.blackoutGroup = 0;
    this.priv_sale = 0;
    this.has_priv = false;
    this.initial_sale = 0;
    this.debug = false;
    this.service_debug = false;
    this.sale = 0;
    this.real_sale = 0;
    this.cashback_sale = 0;
    this.no_cashback_sale = 0;
    this.sale_sum = 0;
    this.domSum = null;
    this.domSale = null;
    this.domSaleSum = null;
    this.name_trunc = '';
    this.privilegeButton = null;
    this.crm = null;
    this.complect = null;
    this.complect_group = null;
    this.infoFields = {};
    this.discount_pics_ids = [];
    this.sale_exceptions = [];
    this.sale_exceptions_cashback = [];
    this.model = {};

    this.controls = {};

    this.additionalDiscount = false;

    this.aiCalculatedPrice = 0;
    this.aiCalculatedSum = 0;
    this.aiCalculatedSale = 0;

    this.AISaleChecked = false;
    this.standartSet = 0;
    this.standartSetParam1 = '';
    this.standartGroup = 0;
    this.autoAdded = false;

    this.boxActionArray = [];
    this.boxAction = false;

    this.xmlId = 0; // id под которым записано в базу в какую xml загрузку попал данный товар

    this.partner = false;

    if (app) {
        if (app.crm) this.crm = app.crm;
        if (app.type === 'complect') {
            this.complect = app;
            this.complect_group = app;

        } else {
            this.complect = app.app;
            this.complect_group = app;
        }

        if (app.crm) {
            this.boxActionArray = app.crm.boxAction;
        } else if (app.boxAction) {
            this.boxActionArray = app.boxAction;
        }
    }
    if (type) this.type = type;
    this.cb = function (param) {
        if (cb) cb(param)
    };
    this.dom = null;
    this.domGroupAdd = null;
    this.domPreview = null;

    this.privilege = function (e, o) {
        if (o) {
            o.style.background = '#339706';
            //console.log(self.priv_mats);
            //console.log(self.app.bubble_data);
            var privilegeBubble = new window.AI_helperPrivilegeClass(this);
            privilegeBubble.showBubble();
            setTimeout(function () {
                o.style.background = '#0c5b94';
            }, 500);
        }
    };
    this.delete = function () {
        if (this.app) this.app.deleteItem(this);
    };
    this.setDomValues = function () {
        // console.log('sdv', this.real_sale, this.additionalDiscount)

        if (this.priv_sale > 0 && !this.additionalDiscount && !this.partner) this.real_sale = this.priv_sale;
        else if (!this.additionalDiscount && !this.partner)
            this.real_sale = this.sale;
        if (this.initial_sale > 0 && !this.additionalDiscount && !this.partner) this.real_sale = Math.max(this.initial_sale, this.real_sale);
        if (this.sale_exceptions.length > 0) {
            let salesT = null;
            for (let i = 0; i < this.sale_exceptions.length; i++) {
                if (window.in_array(this.id, this.sale_exceptions[i].ids)) {
                    salesT = this.sale_exceptions[i];
                    break;
                }
            }
            let sales = salesT;
            if (!sales)
                sales = {
                    type: '',
                    sales: [],
                    limits: [],
                };
            if (!sales.type) sales.type = '';
            if (!sales.sales) sales.sales = [];

            if (sales.type === 'sales' && !this.additionalDiscount && !this.partner) {
                for (let key in sales.sales) {
                    if (Object.prototype.hasOwnProperty.call(sales.sales, key)) {
                        if (this.sale >= parseInt(key)) {
                            if (typeof sales.sales[key] !== "undefined") {
                                this.real_sale = sales.sales[key];
                            }
                        }
                    }
                }
            }
            if (sales.type === 'limits' && !this.additionalDiscount && !this.partner) this.real_sale = this.calcPriceSales(this.wholeSum, sales.limits);
        }
        this.cashback_sale = this.real_sale;
        this.no_cashback_sale = this.real_sale;
        if (this.sale_exceptions_cashback.length > 0 && !this.additionalDiscount && !this.partner) {
            let salesT = null;
            for (let i = 0; i < this.sale_exceptions_cashback.length; i++) {
                if (window.in_array(this.id, this.sale_exceptions_cashback[i].ids)) {
                    salesT = this.sale_exceptions_cashback[i];
                    break;
                }
            }
            let sales = salesT;
            if (sales != null) {
                if (sales.type === 'sales') {
                    for (let key in sales.sales) {
                        if (this.sale >= parseInt(key)) {
                            if (typeof sales.sales[key] !== "undefined") {
                                this.cashback_sale = sales.sales[key];
                            }
                        }
                    }
                }
                //if (sales.type == 'limits') this.real_sale = this.calcPriceSales(this.wholeSum, sales.limits);
            }
        }

        if (!this.partner) {
            this.real_sale = this.cashback_sale;
        }

        // Акция - скидка, если кратно коробке (800)
        if (this.count % 800 == 0 && this.boxActionArray.indexOf(this.id) != -1) {
            this.boxAction = true;
        } else {
            this.boxAction = false;
        }

        this.curPrice = this.price / this.zaEdDeneg;
        if (this.boxAction) {
			this.curPriceSale = this.curPrice - this.curPrice * (this.real_sale + 3) / 100;
		} else {
			this.curPriceSale = this.curPrice - this.curPrice * this.real_sale / 100;
		}

        this.priceRub = this.curPrice * this.curRate;
        this.sum = this.priceRub * this.count;
        this.priceRubSale = this.curPriceSale * this.curRate;
        this.sale_sum = this.priceRubSale * this.count;
        let no_cashback_RubSale = (this.curPrice - this.curPrice * this.no_cashback_sale / 100) * this.curRate * this.count;
        let cashback_RubSale = (this.curPrice - this.curPrice * this.cashback_sale / 100) * this.curRate * this.count;
        this.cashbackSum = no_cashback_RubSale - cashback_RubSale;
        if (this.cashbackSum < 0) this.cashbackSum = 0;
        this.cashbackSum = Math.round(this.cashbackSum * 10000) / 10000;
        this.curPriceSale = Math.round(this.curPriceSale * 10000) / 10000;
        this.priceRub = Math.round(this.priceRub * 10000) / 10000;
        this.sum = Math.round(this.sum * 100) / 100;
        this.priceRubSale = Math.round(this.priceRubSale * 10000) / 10000;
        this.sale_sum = Math.round(this.sale_sum * 100) / 100;
        //console.log(this.no_cashback_sale, '=>', this.cashback_sale, '=', this.cashbackSum);
        /*
                        console.log('price',this.price);
                        console.log('zaEdDeneg',this.zaEdDeneg);
                        console.log('curPrice',this.curPrice);
                        console.log('curPriceSale',this.curPriceSale);
                        console.log('priceRub',this.priceRub);
                        console.log('sum',this.sum);
                        console.log('priceRubSale',this.priceRubSale);
                        console.log('sale_sum',this.sale_sum);
        */
        if (this.controls.inputGroupAdd) {
            this.controls.inputGroupAdd.value = this.count.toFixed(2);
            this.controls.inputGroupAdd.style.backgroundColor = 'rgb(104, 215, 129)';
        }
        if (this.controls.input) {
            this.controls.input.value = this.count.toFixed(2);
            this.controls.input.style.backgroundColor = 'rgb(104, 215, 129)';
        }

        if (!this.enableStock) {
            if (this.controls.sumGroupAdd) this.controls.sumGroupAdd.style.display = 'none';
            if (this.controls.sale_sumGroupAdd) this.controls.sale_sumGroupAdd.style.display = 'none';

            if (this.controls.controlsGroupAdd) this.controls.controlsGroupAdd.style.display = 'none';
            if (this.controls.addButtonGroupAdd) this.controls.addButtonGroupAdd.style.display = 'none';
            if (this.controls.privilegeGroupAdd) {
                if (this.has_priv)
                    this.controls.privilegeGroupAdd.style.display = 'auto';
                else
                    this.controls.privilegeGroupAdd.style.display = 'none';
            }
            if (this.controls.addStubGroupAdd) this.controls.addStubGroupAdd.style.display = 'auto';
        } else {
            if (this.controls.sumGroupAdd) this.controls.sumGroupAdd.style.display = 'auto';
            if (this.controls.sale_sumGroupAdd) this.controls.sale_sumGroupAdd.style.display = 'auto';

            if (this.controls.controlsGroupAdd) this.controls.controlsGroupAdd.style.display = 'auto';
            if (this.controls.addButtonGroupAdd) this.controls.addButtonGroupAdd.style.display = 'auto';
            if (this.controls.privilegeGroupAdd) this.controls.privilegeGroupAdd.style.display = 'none';
            if (this.controls.addStubGroupAdd) this.controls.addStubGroupAdd.style.display = 'none';

            // let priceRub = Math.floor(this.priceRub * 100) / 100;
            // let priceRubSale = Math.floor(this.priceRubSale * 100) / 100;
            // this.renderFields('sum', this.sum);
            // this.renderFields('priceRub', priceRub);
            // this.renderFields('sale_sum', this.sale_sum);
            // this.renderFields('priceRubSale', priceRubSale);
            // this.renderFields('real_sale', this.real_sale);
            // this.renderFields('count', this.count);
            //console.log('ITEM:',this);
        }
        // console.log('sdv2', this.real_sale)
    };
    this.inputChange = function (e, o) {
        this.handlersInput(o);
    };
    this.inputKeyUp = function (e, o) {
        if (o.keyCode === 13) {
            this.handlersInput(o);
        }
    };
    this.handlersPlus = function () {
        let v = 0;
        if (this.controls.input) v = parseFloat(this.controls.input.value);
        if (this.controls.inputGroupAdd) v = parseFloat(this.controls.inputGroupAdd.value);
        let count = v + this.package;
        if (count <= this.gdsInStock) {
            this.count = v + this.package;
            this.setDomValues();
            this.cb(this);
        } else {
            this.handlersErr();
        }
    };
    this.handlersMinus = function () {
        let v = 0;
        if (this.controls.input) v = parseFloat(this.controls.input.value);
        if (this.controls.inputGroupAdd) v = parseFloat(this.controls.inputGroupAdd.value);
        let count = v - this.package;
        if (v <= 0) {
            if (this.app) this.app.deleteItem(this);
        } else if (count <= this.gdsInStock) {
            this.count = v - this.package;
            this.setDomValues();
            this.cb(this);
        } else {
            this.handlersErr();
        }
    };
    this.handlersInput = function (o) {
        let v = parseFloat(o.value);
        if (isNaN(v)) v = 0;
        let t = 0;
        let gt = 0;
        let gv = this.gdsInStock;
        if (this.package !== 0) {
            t = v % this.package;
            if (t > 0) {
                let tt = Math.round(v / this.package);
                v = tt * this.package;
            }
//----------
            gt = gv % this.package;
            if (gt > 0) {
                let tt = Math.round(gv / this.package);
                gv = tt * this.package;
            }
        }
        //console.log(v,gv);
        //if (v <= this.gdsInStock) {
        if (v <= gv) {
            this.count = v;
            if (this.count < 0) this.count = 0;
            this.setDomValues();
            this.cb(this);
        } else {
            this.handlersErr();
        }
    };
    this.handlersErr = function () {
        let self = this;
        if (self.controls.alertGroupAdd) self.controls.alertGroupAdd.style.visibility = 'visible';
        if (self.controls.alert) self.controls.alert.style.visibility = 'visible';
        if (self.controls.inputGroupAdd) self.controls.inputGroupAdd.style.backgroundColor = 'rgb(244, 111, 128)';
        if (self.controls.input) self.controls.input.style.backgroundColor = 'rgb(244, 111, 128)';
        setTimeout(function () {
            if (self.controls.alertGroupAdd) self.controls.alertGroupAdd.style.visibility = 'hidden';
            if (self.controls.alert) self.controls.alert.style.visibility = 'hidden';
            if (self.controls.inputGroupAdd) {
                self.controls.inputGroupAdd.value = self.count.toFixed(2);
                self.controls.inputGroupAdd.style.backgroundColor = 'rgb(104, 215, 129)';
            }
            if (self.controls.input) {
                self.controls.input.value = self.count.toFixed(2);
                self.controls.input.style.backgroundColor = 'rgb(104, 215, 129)';
            }
        }, 1000);
    };
    this.add = function (e, o) {
        let self = this;
        o.setAttribute('value', 'Добавлено');
        o.style.background = '#339706';
        if (self.controls.rowGroupAdd) self.controls.rowGroupAdd.style.background = 'rgb(255, 231, 135) none repeat scroll 0% 0%';
        setTimeout(function () {
            if (!self.added)
                if (self.controls.rowGroupAdd) self.controls.rowGroupAdd.style.display = 'none';
            self.addItem();
        }, 300);
    };
    this.initDom = function () {
        // if (this.app.additionalDiscount) this.additionalDiscount = this.app.additionalDiscount;

        // if (this.group == 0) {
        //     for (let obj in this.additionalDiscount) {
        //         if (this.additionalDiscount[obj].goodID == this.id) {
        //             this.real_sale = this.additionalDiscount[obj].discount;
        //         }
        //     }
        // }

        // let action ='';
        // if (this.discount_pics_ids.indexOf(this.id) !== -1) {
        // 	action = ' ihelper_sale_summ_cashBack';
        // }
        // this.model={
        // 	id:this.id,
        // 	name:this.name,
        // 	img:this.img,
        // 	cnt_per_all:this.cnt_per_all,
        // 	package:this.package,
        // 	priceRub:this.priceRub,
        // 	stockAlt:this.prihod?this.prihod:this.stockAlt,
        // 	stockColor:this.stockColor,
        // 	tabindex:1000,
        // 	count:this.count,
        // 	sum:this.sum,
        // 	measure:this.measure,
        // 	real_sale:this.real_sale,
        // 	sale_sum:this.sale_sum,
        // 	priceRubSale:this.priceRubSale,
        // 	action:action,
        // };
        // switch(this.type) {
        // 	case 'common':		this.createDom(); break;
        // 	case 'groupAdd':	this.createDomGroupAdd(); break;
        // 	case 'preview':		this.createDomPreview(); break;
        // }
        // this.setDomValues();
    };
    this.createDom = function () {
        // this.dom = new HtmlDom(itemTemplate, this.model, this);
        // this.controls.del = this.dom.querySelectorAll('[controls="del"]')[0];
        // this.controls.input = this.dom.querySelectorAll('[controls="input"]')[0];
        // this.controls.alert = this.dom.querySelectorAll('[controls="alert"]')[0];
        // this.infoFields.dom = {};
        // this.infoFields.dom.sum = this.dom.querySelectorAll('[model="sum"]')[0];
        // this.infoFields.dom.priceRub = this.dom.querySelectorAll('[model="priceRub"]')[0];
        // this.infoFields.dom.sale_sum = this.dom.querySelectorAll('[model="sale_sum"]')[0];
        // this.infoFields.dom.priceRubSale = this.dom.querySelectorAll('[model="priceRubSale"]')[0];
        // this.infoFields.dom.real_sale = this.dom.querySelectorAll('[model="real_sale"]')[0];
        // this.infoFields.dom.count = this.dom.querySelectorAll('[model="count"]')[0];
        // this.dom = this.dom.children[0];
    };
    this.createDomGroupAdd = function () {
        // this.domGroupAdd = new HtmlDom(itemGroupAddTemplate, this.model, this);
        // this.controls.rowGroupAdd = this.domGroupAdd.querySelectorAll('[controls="row"]')[0];
        // this.controls.inputGroupAdd = this.domGroupAdd.querySelectorAll('[controls="input"]')[0];
        // this.controls.alertGroupAdd = this.domGroupAdd.querySelectorAll('[controls="alert"]')[0];
        // this.controls.controlsGroupAdd = this.domGroupAdd.querySelectorAll('[controls="controls"]')[0];
        // this.controls.privilegeGroupAdd = this.domGroupAdd.querySelectorAll('[controls="privilege"]')[0];
        // this.controls.privilegeButton = this.domGroupAdd.querySelectorAll('[controls="privilegeButton"]')[0];
        // this.controls.addButtonGroupAdd = this.domGroupAdd.querySelectorAll('[controls="addButton"]')[0];
        // this.controls.addStubGroupAdd = this.domGroupAdd.querySelectorAll('[controls="addStub"]')[0];
        // this.controls.sumGroupAdd = this.domGroupAdd.querySelectorAll('[controls="sum"]')[0];
        // this.controls.sale_sumGroupAdd = this.domGroupAdd.querySelectorAll('[controls="sale_sum"]')[0];
        // this.infoFields.domGroupAdd = {};
        // this.infoFields.domGroupAdd.sum = this.domGroupAdd.querySelectorAll('[model="sum"]')[0];
        // this.infoFields.domGroupAdd.priceRub = this.domGroupAdd.querySelectorAll('[model="priceRub"]')[0];
        // this.infoFields.domGroupAdd.sale_sum = this.domGroupAdd.querySelectorAll('[model="sale_sum"]')[0];
        // this.infoFields.domGroupAdd.priceRubSale = this.domGroupAdd.querySelectorAll('[model="priceRubSale"]')[0];
        // this.infoFields.domGroupAdd.real_sale = this.domGroupAdd.querySelectorAll('[model="real_sale"]')[0];
        // this.infoFields.domGroupAdd.count = this.domGroupAdd.querySelectorAll('[model="count"]')[0];
        // //this.domGroupAdd = this.domGroupAdd.children[0];
    };
    this.createDomPreview = function () {
        // this.domPreview = new HtmlDom(itemPreviewTemplate, this.model, this);
        // this.infoFields.domPreview = {};
        //this.domPreview = this.domPreview.children[0];
    };
    this.release = function () {
        return {
            id: this.id,
            img: this.img,
            name: this.name,
            package: this.package,
            measure: this.measure,
            priceRub: this.priceRub,
            enableStock: this.enableStock,
            cnt_per_all: this.cnt_per_all,
            stockAlt: this.stockAlt,
            stockColor: this.stockColor,
            rec_count: this.rec_count,
            sum: this.sum,
            count: this.count,
            default_rec: this.default_rec,
            group: this.group,
            rate: this.rate,
            last_count: this.last_count,
            dbg: this.dbg,
            added: this.added,
            inputTimeout: this.inputTimeout,
            prihod: this.prihod,
            wholeSum: this.wholeSum,
            curPrice: this.curPrice,
            price: this.price,
            zaEdDeneg: this.zaEdDeneg,
            curRate: this.curRate,
            debug: this.debug,
            service_debug: this.service_debug,
            sale: this.sale,
            real_sale: this.real_sale,
            sale_sum: this.sale_sum,
            name_trunc: this.name_trunc,
            sale_exceptions: this.sale_exceptions,
            sale_exceptions_cashback: this.sale_exceptions_cashback,
            discount_pics_ids: this.discount_pics_ids,
            curPriceSale: this.curPriceSale,
            priceRubSale: this.priceRubSale,
            restore: true,
            gdsInStock: this.gdsInStock,
            priceGroup: this.priceGroup,
            colorGroup: this.colorGroup,
            blackoutGroup: this.blackoutGroup,
            priv_sale: this.priv_sale,
            has_priv: this.has_priv,
            priv_mats: this.priv_mats,
            initial_sale: this.initial_sale,
            additionalDiscount: this.additionalDiscount,
            aiCalculatedPrice: this.aiCalculatedPrice,
            aiCalculatedSum: this.aiCalculatedSum,
            aiCalculatedSale: this.aiCalculatedSale,
            AISaleChecked: this.AISaleChecked,
            standartSet: this.standartSet,
            standartSetParam1: this.standartSetParam1,
            standartGroup: this.standartGroup,
            xmlId: this.xmlId,
            partner: this.partner
        };
    };
    this.init = function (o) {
        if (o != null) {
            if (typeof o.restore !== "undefined")
                this.init_restore(o);
            else
                this.init_new(o);

            if (this.app && this.app.bubble_data) {
                let new_priv_mat = [];
                for (let kp in this.priv_mats) {
                    if (Object.prototype.hasOwnProperty.call(this.priv_mats, kp)) {
                        let vp = this.priv_mats[kp];
                        if (typeof this.app.bubble_data[vp] !== "undefined") {
                            if (this.app.bubble_data[vp].enableStock) {
                                new_priv_mat.push(vp);
                            }
                        }
                    }
                }
                this.priv_mats = new_priv_mat;
            }

            if (typeof this.priv_mats !== "undefined")
                if (this.priv_mats.length <= 0) this.has_priv = false;
        }
        //console.log('this.priv_mats',this.priv_mats);
    };
    this.init_restore = function (o) {
        // console.log('RESTORE ITEM', o);

        for (let key in o) {
            if (Object.prototype.hasOwnProperty.call(o, key)) {
                if (o[key]) this[key] = o[key];
            }
        }

        this.initDom();
    };
    this.init_new = function (o) {
        // console.log('NEW ITEM', o);
        if (this.app) {
            if (this.app.sale) this.sale = this.app.sale;

            //console.log('ITEM SALE:', this.app.sale);
            if (this.app.wholeSum) this.wholeSum = this.app.wholeSum;
            if (this.app.debug) this.debug = this.app.debug;
            if (this.app.service_debug) this.service_debug = this.app.service_debug;
            if (this.app.sale_exceptions) this.sale_exceptions = this.app.sale_exceptions;
            if (this.app.sale_exceptions_cashback) this.sale_exceptions_cashback = this.app.sale_exceptions_cashback;
            if (this.app.discount_pics_ids) this.discount_pics_ids = this.app.discount_pics_ids;

            // if (this.app.exc_sales)		this.exc_sales 	    =	this.app.exc_sales;
        }

        if (o.id) this.id = parseInt(o.id); //id_good
        if (o.img) this.img = o.img;
        if (o.name) this.name = o.name;// + ' ('+this.id+')';
        if (o.name_trunc) this.name_trunc = o.name_trunc;// + ' ('+this.id+')';
        if (this.name_trunc !== '')
            this.name = this.name_trunc;
        if (o.package) this.package = parseFloat(o.package);
        if (o.measure) this.measure = o.measure;
        if (o.enableStock) this.enableStock = o.enableStock;
        if (o.cnt_per_all) this.cnt_per_all = parseFloat(o.cnt_per_all);
        if (o.stockAlt) this.stockAlt = o.stockAlt;
        if (o.stockColor) this.stockColor = o.stockColor;
        //if (o.sum)) this.sum=						parseFloat(o.sum);
        if (o.count) this.count = parseFloat(o.count);

        // Акция - скидка, если кратно коробке (800)
        if (o.count % 800 == 0 && this.boxActionArray.indexOf(o.id) != -1) {
            this.boxAction = true;
            // this.real_sale += 3;
        } else {
            this.boxAction = false;
        }

        this.rec_count = this.count;
        if (o.default_rec) this.default_rec = o.default_rec;
        if (o.group) this.group = parseInt(o.group);
        if (o.rate) this.rate = parseFloat(o.rate);
        if (o.last_count) this.last_count = parseFloat(o.last_count);
        if (o.dbg) this.dbg = o.dbg;
        if (o.prihod) this.prihod = o.prihod;
        if (o.price) this.price = parseFloat(o.price);
        if (o.curPrice) this.curPrice = parseFloat(o.curPrice);
        if (o.zaEdDeneg) this.zaEdDeneg = parseFloat(o.zaEdDeneg);
        if (o.curRate) this.curRate = parseFloat(o.curRate);
        if (o.gdsInStock) this.gdsInStock = parseFloat(o.gdsInStock);
        if (o.priceGroup) this.priceGroup = o.priceGroup;
        if (o.colorGroup) this.colorGroup = o.colorGroup;
        if (o.blackoutGroup) this.blackoutGroup = o.blackoutGroup;
        if (o.priv_sale) this.priv_sale = parseFloat(o.priv_sale);
        if (o.has_priv) this.has_priv = o.has_priv;
        if (o.priv_mats) this.priv_mats = o.priv_mats;
        if (o.initial_sale) this.initial_sale = parseFloat(o.initial_sale);
        if (o.real_sale) this.real_sale = parseFloat(o.real_sale);
        if (o.sale) this.sale = parseFloat(o.sale);
        if (o.additionalDiscount) this.additionalDiscount = o.additionalDiscount;
        if (o.xmlId) this.xmlId = o.xmlId;
        if (o.partner) this.partner = o.partner;

        this.curPrice = this.price / this.zaEdDeneg;
        // this.curPriceSale = Math.round((this.curPrice - this.curPrice * this.real_sale / 100) * 10000) / 10000;

        if (this.boxAction) {
            // this.curPriceSale = this.curPrice - this.curPrice * (this.real_sale + 3) / 100;
            this.curPriceSale = Math.round((this.curPrice - this.curPrice * (this.real_sale + 3) / 100) * 10000) / 10000;
        } else {
            // this.curPriceSale = this.curPrice - this.curPrice * this.real_sale / 100;
            this.curPriceSale = Math.round((this.curPrice - this.curPrice * this.real_sale / 100) * 10000) / 10000;
        }

        this.priceRub = Math.round(this.curPrice * this.curRate * 10000) / 10000;
        this.sum = Math.round(this.priceRub * this.count * 100) / 100;
        this.priceRubSale = Math.round(this.curPriceSale * this.curRate * 10000) / 10000;
        this.sale_sum = Math.round(this.priceRubSale * this.count * 100) / 100;
        this.curPrice = this.price / this.zaEdDeneg;
        this.curPriceSale = this.curPrice - this.curPrice * this.real_sale / 100;
        this.priceRub = this.curPrice * this.curRate;
        this.sum = this.priceRub * this.count;
        this.priceRubSale = this.curPriceSale * this.curRate;
        this.sale_sum = this.priceRubSale * this.count;
        this.curPriceSale = Math.round(this.curPriceSale * 10000) / 10000;
        this.priceRub = Math.round(this.priceRub * 10000) / 10000;
        this.sum = Math.round(this.sum * 100) / 100;
        this.priceRubSale = Math.round(this.priceRubSale * 10000) / 10000;
        this.sale_sum = Math.round(this.sale_sum * 100) / 100;
        this.initDom();
    };
    this.addItem = function () {
        this.added = true;
        if (this.app != null) {
            this.createDom();
            this.app.addItem(this);
        }
    };
    this.append = function () {
        // if (this.priceRub > 0)
        // container.appendChild(this.dom);
    };
    this.appendGroupAdd = function () {
        // if (this.priceRub > 0)
        // 	container.appendChild(this.domGroupAdd);
    };
    this.appendPreview = function () {
        // container.appendChild(this.domPreview);
    };
    this.toCart = function () {
    };
    this.setSale = function (sale, sum) {
        this.sale = sale;
        this.wholeSum = sum;
        this.setDomValues();
    };
    this.calcPriceSales = function (sum, sale_limits) {
        let prevV = 0;
        let prevK = 0;
        let actV = 0;
        let actK = 0;
        let sale;

        //console.log('sale_limits', sale_limits, sum);
        for (let k in sale_limits) {
            if (Object.prototype.hasOwnProperty.call(sale_limits, k)) {
                let v = sale_limits[k];
                actK = parseInt(k);
                actV = parseInt(v) * 1000;
                //console.log('act', actK, actV);
                //console.log('prev', prevK, prevV);
                if (prevV >= sum) {
                    //console.log(prevV,'>=',sum);
                    sale = prevK;
                    break;
                } else {
                    prevV = actV;
                    prevK = actK;
                }
            }
        }
        sale = prevK;
        return sale / 10;
    };
    this.renderFields = function (model, value) {
        for (let key in this.infoFields) {
            if (Object.prototype.hasOwnProperty.call(this.infoFields, key)) {
                let block = this.infoFields[key];
                if (block[model]) {
                    if (typeof value === 'string') {
                        block[model].innerHTML = value;
                    } else {
                        block[model].innerHTML = window.number_format(value, 2, '.', ' ');
                    }
                } //else console.log('notfound:', key, model);
            }
        }
    };
    this.init(o);
}; //class
export default AI_helperItemClass;
